import { useQuery } from '@tanstack/react-query';
// import FormInputAsycnPaginate from '../../shared/FormInputAsycnPaginate';
import FormSelect from '../../shared/FormSelect.jsx';
import { fetchTemplateRiderComp } from '../../../utils/apiUtils.js';
import { SLOT_NAMES } from '../../../utils/constants.js';

const step = 16

const StepSixteen = ({ activeStep, control, errors, setValue, getValues }) => {
    if (activeStep !== step) return;

    const template = getValues("template")
    const account = getValues("account")

    const { data: exclusionsOptions } = useQuery({
        queryKey: ['getExclusions'],
        queryFn: async () => {
            const results = await fetchTemplateRiderComp({
                size: 100,
                searchText: 'STANDARD - MEDICAL - EXCLUSIONS',
                // bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
                benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey
            });
            return results
        },

        select: (data) => data.hits.hits.map(hit => hit._source.metadata)
            .map((metadata, i) => ({
                value: metadata.benefitPlanCompName,
                label: `${metadata.benefitPlanCompName}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
                additional: metadata,
            })),
        enabled: !!template?.additional?.benefitPlanTemplateKey
    })

    const { data: clientSpecificExclusionsOptions } = useQuery({
        queryKey: ['getClientSpecificExclusionsOptions'],
        // queryFn: async () => {
        //     const results = await fetchTemplateRiderComp({
        //         size: 100,
        //         category: SLOT_NAMES.EXCLUSIONS,
        //         searchText: account?.label,
        //         benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey
        //         //  bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        //     });
        //     return results
        // },

        // select: (data) => data.hits.hits.map(hit => hit._source.metadata)
        //     .map((metadata, i) => ({
        //         value: metadata.benefitPlanCompName,
        //         label: `${metadata.benefitPlanCompName}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
        //         additional: metadata,
        //     })),

        queryFn: async () => await fetchGetLatestTemplateRiderComponent({
            slotName: SLOT_NAMES.EXCLUSIONS,
            searchText: account?.label,
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            limit: 100
        }),
        select: (data) => data.rows.map((metadata, i) => ({
            value: metadata.benefitPlanRiderHccId,
            label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
            additional: metadata,
        })),

        enabled: !!template?.additional?.benefitPlanTemplateKey
    })

    const { data: limitsOptions } = useQuery({
        queryKey: ['getLimits'],
        // queryFn: async () => {
        //     const results = await fetchTemplateRiderComp({
        //         size: 100,
        //         searchText: 'Centivo Standard',
        //         category: SLOT_NAMES.LIMITS,
        //         benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey
        //         //  bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey,
        //     });
        //     return results
        // },

        // select: (data) => data.hits.hits.map(hit => hit._source.metadata)
        //     .map((metadata, i) => ({
        //         value: metadata.benefitPlanCompName,
        //         label: `${metadata.benefitPlanCompName}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
        //         additional: metadata
        //     })),



        queryFn: async () => await fetchGetLatestTemplateRiderComponent({
            slotName: SLOT_NAMES.LIMITS,
            searchText: 'Centivo Standard',
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            limit: 100
        }),
        select: (data) => {
            const arr = data.rows.
                filter().
                map((metadata, i) => ({
                    value: metadata.benefitPlanRiderHccId,
                    label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
                    additional: metadata,
                }))
            return [...new Map(arr.map(item => [item.value, item])).values()]
        },

        enabled: !!template?.additional?.benefitPlanTemplateKey
    })

    const { data: clientSpecificLimitsOptions } = useQuery({
        queryKey: ['getClientSpecificLimitsOptions'],
        // queryFn: async () => {
        //     const results = await fetchTemplateRiderComp({
        //         size: 100,
        //         category: SLOT_NAMES.LIMITS,
        //         searchText: account?.label?.split(' ')?.[0],
        //         filterText: 'Centivo Standard',
        //         //  bnftPlanTemplateHstFctKey: template?.additional?.bnftPlanTemplateHstFctKey
        //         benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey

        //     });
        //     return results
        // },

        // select: (data) => {

        //     const arr = data.hits.hits.map(hit => hit._source.metadata)
        //         .map((metadata, i) => ({
        //             value: metadata.benefitPlanRiderHccId,
        //             label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
        //             additional: metadata
        //         }))

        //     return [...new Map(arr.map(item => [item.value, item])).values()]
        // }
        // ,


        queryFn: async () => await fetchGetLatestTemplateRiderComponent({
            slotName: SLOT_NAMES.LIMITS,
            searchText: account?.label?.split(' ')?.[0],
            benefitPlanTemplateKey: template?.additional?.benefitPlanTemplateKey,
            limit: 100
        }),
        select: (data) => {
            const arr = data.rows.
                filter(metadata => !metadata.benefitPlanRiderHccId.includes('Centivo Standard')).
                map((metadata, i) => ({
                    value: metadata.benefitPlanRiderHccId,
                    label: `${metadata.benefitPlanRiderHccId}`, //`${row.accountHccId} ${row.parentAccountNames ? ` ( TopAcct: ${row.parentAccountNames} )` : ""}`,
                    additional: metadata,
                }))
            return [...new Map(arr.map(item => [item.value, item])).values()]
        },

        enabled: !!template?.additional?.benefitPlanTemplateKey
    })

    return (
        <>
            {/* <p style={{ padding: '0rem 0rem 1rem 0rem' }}>{template?.label}</p> */}
            <p style={{ fontWeight: '600', padding: '0rem 0rem 1rem 0rem' }}>Exclusions</p>
            <FormSelect
                label={'Default exclusion from Template'}
                name={'exclusions.default'}
                control={control}
                options={exclusionsOptions}
                errors={errors}
                placeholder="Select..."
                disabled={true}
            // onSelectedHandler={({ value }) => {

            // }}
            />

            <FormSelect
                label={'Client Specific Exclusions'}
                name={'exclusions.clientSpecific'}
                control={control}
                options={clientSpecificExclusionsOptions}
                errors={errors}
                placeholder="Select..."
            // onSelectedHandler={({ value }) => {

            // }}
            />

            <p style={{ fontWeight: '600', padding: '1rem 0rem 1rem 0rem' }}>Limits</p>
            <FormSelect
                label={'Default limit from Template'}
                name={'limits.default'}
                control={control}
                options={limitsOptions}
                errors={errors}
                placeholder="Select..."
                disabled={true}
            />

            <FormSelect
                label={'Overwrite Default limit from Template'}
                name={'limits.overwriteDefault'}
                control={control}
                options={limitsOptions}
                errors={errors}
                placeholder="Select..."
            />

            <FormSelect
                label={'Client Specific Limits'}
                name={'limits.clientSpecific'}
                control={control}
                options={clientSpecificLimitsOptions}
                errors={errors}
                placeholder="Select..."
                isMulti={true}
            // onSelectedHandler={({ value }) => {

            // }}
            />


        </>
    )
}

export default StepSixteen
